/** CoStar.Api.SuiteDetail.OwnerInvestmentBrokersByVolume.SortType */
export var SortType;
(function (SortType) {
    SortType[SortType["None"] = 0] = "None";
    SortType[SortType["BrokerNameAsc"] = 1] = "BrokerNameAsc";
    SortType[SortType["BrokerNameDesc"] = 2] = "BrokerNameDesc";
    SortType[SortType["SaleCountAsc"] = 3] = "SaleCountAsc";
    SortType[SortType["SaleCountDesc"] = 4] = "SaleCountDesc";
    SortType[SortType["SaleValueAsc"] = 5] = "SaleValueAsc";
    SortType[SortType["SaleValueDesc"] = 6] = "SaleValueDesc";
    SortType[SortType["WebsiteAsc"] = 7] = "WebsiteAsc";
    SortType[SortType["WebsiteDesc"] = 8] = "WebsiteDesc";
    SortType[SortType["CityAsc"] = 9] = "CityAsc";
    SortType[SortType["CityDesc"] = 10] = "CityDesc";
    SortType[SortType["PostCodeAsc"] = 11] = "PostCodeAsc";
    SortType[SortType["PostCodeDesc"] = 12] = "PostCodeDesc";
    SortType[SortType["CountryNameAsc"] = 13] = "CountryNameAsc";
    SortType[SortType["CountryNameDesc"] = 14] = "CountryNameDesc";
    SortType[SortType["RegionNameAsc"] = 15] = "RegionNameAsc";
    SortType[SortType["RegionNameDesc"] = 16] = "RegionNameDesc";
})(SortType || (SortType = {}));
